// src/lib/http/bff.ts
import { createBffClient } from './bffClient';
import { notifyAuthDisconnected } from '@/lib/auth/authDisconnect';

// Re-export the structured error so callers can `instanceof`-check
// without reaching into the lower-level `bffClient` module.
export { BffError } from './bffClient';
export type { BffErrorBody } from './bffClient';

const origin =
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';

export const bff = createBffClient({
  origin,           // -> http://localhost:3000 (CRA dev)
  basePath: '/bff', // client will call /bff/*
  // timeoutMs, defaultHeaders, getAuthHeaders... (optional)
  onUnauthenticated: () => {
    if (typeof window === 'undefined') return;
    // Avoid redirect loops if we're already on the login route.
    if (window.location.pathname.startsWith('/login')) return;
    notifyAuthDisconnected({ reason: 'unauthenticated' });
  },
});
